import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query"

import client from "utils/client"

export const useOrderTags = (id, params, options = {}) => {
  return useQuery({
    queryKey: ["v2", "campaigns", "orders", "tags", "index", id, params],
    queryFn: async () => {
      const res = await client.get(`/v2/campaigns/orders/${id}/tags.json`, {
        params
      })

      return res.data
    },
    enabled: false,
    ...options
  })
}

export const useCreateOrderTags = (id) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (values) => {
      const response = await client.post(
        `/v2/campaigns/orders/${id}/tags.json`,
        {
          tags: values
        }
      )

      return response.data
    },

    onSuccess: () => {
      queryClient.invalidateQueries([
        "v2",
        "campaigns",
        "orders",
        "tags",
        "index",
        id
      ])
      queryClient.invalidateQueries({
        queryKey: ["v2", "campaigns", "clusters"]
      })
      queryClient.invalidateQueries({
        queryKey: ["v2", "campaigns", "orders"]
      })
      queryClient.invalidateQueries({
        queryKey: ["statistics", "campaigns"]
      })
    }
  })
}
